import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "ÄŒaj",
  "description": "",
  "published": "2007-04-27T00:00:00.000Z",
  "redirect_from": ["/blog/aj/swizec/224"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ta blog bi moral biti narejen Å¾e prejšnjo noÄ, a mi je nekako uspelo zaspati med gledanjem Sherlocka Holmesa še predenj je zavrela voda za Äaj. Nenavadno ...`}</p>
    <p>{`VÄeraj je bil z mano posnet intervju in kljub temu, da sem take stvari poÄel prviÄ, sem se nenavadno zabaval. Amaterskost poÄetja je bila oÄitna v popolni nepripravljenosti obeh udeleÅ¾encev in da mi nekako ni bilo dovoljeno spustiti se v dolge razvleÄene odgovore. MogoÄe pa mi beseda le ni tekla tako dobro, kot sem mislil. Moral bom delati na svoji govorni elokvenci.`}</p>
    <p>{`Zdaj pa še, Äisto iz osebne muhe, `}<a parentName="p" {...{
        "href": "http://flickr.com/photos/7280946@N06/474283871/"
      }}>{`panoramska fotografija`}</a>{` moje najljubše Äajnice, ki me futra s Äajem skoraj vsak dan.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      